package com.willandsons.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.px

@Composable
fun AppCard(
    titleContent: @Composable () -> Unit = {},
    description: String,
    status: String,
    statusColor: Color,
    borderColor: Color,
    googlePlayLink: String?,
    appStoreLink: String?,
    otherLinks: List<Pair<String, String>> = emptyList()
) {
    Surface(
        modifier = Modifier
            .fillMaxWidth()
            .margin(2.em)
            .padding(2.em)
            .borderRadius(1.em)
            .border {
                width(2.px)
                style(LineStyle.Solid)
                color(borderColor)
            }
    ) {
        Column(
            modifier = Modifier.gap(1.em)
        ) {
            // Title
            Row(Modifier.fontSize(2.em).fontWeight(FontWeight.Bold).gap(1.cssRem), verticalAlignment = Alignment.CenterVertically) {
                titleContent()
            }

            // Description
            SpanText(
                text = description,
                modifier = Modifier.fontSize(1.em).opacity(0.85)
            )

            Row {
                SpanText(
                    text = "Status: ",
                    modifier = Modifier.fontWeight(FontWeight.Medium)
                )
                SpanText(
                    text = status,
                    modifier = Modifier.color(statusColor).fontWeight(FontWeight.Medium)
                )
            }

            // Download buttons row
            if (googlePlayLink != null || appStoreLink != null) {
                Row(modifier = Modifier.gap(1.em)) {
                    googlePlayLink?.let {
                        Link(googlePlayLink) {
                            Image(
                                "/GetItOnGooglePlay-Badge.svg",
                                "Get it on Google Play",
                                height = 40
                            )
                        }
                    }

                    appStoreLink?.let {
                        Link(appStoreLink) {
                            Image(
                                "/Download-on-the-App-Store-Badge.svg",
                                "Download on the App Store",
                                height = 40
                            )
                        }
                    }
                }
            }

            // Other links
            if (otherLinks.isNotEmpty()) {
                Row(
                    modifier = Modifier.fontSize(0.8.em)
                ) {
                    otherLinks.forEachIndexed { index, (label, link) ->
                        if (index > 0) {
                            SpanText(" • ")
                        }
                        Link(link, label, variant = UncoloredLinkVariant)
                    }
                }
            }
        }
    }
}